<ng-lottie width="100%" height="100%" [options]="{ path: path, renderer: 'canvas' }"></ng-lottie>
